module.exports = __webpack_public_path__ + "static/media/dance-02.142f614d.jpg";